module.exports = __webpack_public_path__ + "img/arrow3.0d8f24a1.svg";